export default __webpack_public_path__ + "static/media/aocaboteatro3.528e8bec.png";